import { ActionType, createAction } from "typesafe-actions";

import BoundaryType from "@mapmycustomers/shared/enum/BoundaryType";
import BoundaryLegend from "@mapmycustomers/shared/types/map/BoundaryLegend";

export const showCreateBoundaryLegendWizard = createAction("@boundaryLegendsUi/wizard/show")<
  | {
      boundaryLegend: BoundaryLegend;
    }
  | { boundaryType: BoundaryType }
>();

export const hideCreateBoundaryLegendWizard = createAction(
  "@boundaryLegendsUi/wizard/hide"
)<void>();

export const showUpdateBoundaryLegendDrawer = createAction(
  "@boundaryLegendsUi/drawer/show"
)<BoundaryLegend>();

export const hideBoundaryLegendDrawer = createAction("@boundaryLegendsUi/drawer/hide")<void>();

export const showBoundarySettingsPopover = createAction("@boundaryLegendsUi/openPopover")<
  BoundaryType | undefined
>();

export type BoundaryLegendsActions = ActionType<
  | typeof hideBoundaryLegendDrawer
  | typeof hideCreateBoundaryLegendWizard
  | typeof showBoundarySettingsPopover
  | typeof showCreateBoundaryLegendWizard
  | typeof showUpdateBoundaryLegendDrawer
>;
